import { boot } from '@dazn/bootstrap-lib';

import { createUUID } from './createUUID';

export const getGuid = (
    load: boot.storage.AsyncStorage['getItem'],
    save: boot.storage.AsyncStorage['setItem'],
    createGuid: () => string = createUUID,
): Promise<string> =>
    load('guid').then(id => {
        let guid = id;
        if (!guid) {
            guid = createGuid();
            save('guid', guid);
        }

        return guid;
    });
